import { PASSWORD_ENCRYPTION_CONFIG } from "services";

const pemToArrayBuffer = (pem) => {
  const base64 = pem
    .replace("-----BEGIN PUBLIC KEY-----", "")
    .replace("-----END PUBLIC KEY-----", "")
    .replace(/\s/g, "");
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

const toBase64 = (arrayBuffer) => {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

export const encryptPasswordIfEnabled = async (password) => {
  if (!PASSWORD_ENCRYPTION_CONFIG?.enabled || !password) return password;

  const keyData = pemToArrayBuffer(PASSWORD_ENCRYPTION_CONFIG.public_key_pem);
  const cryptoKey = await window.crypto.subtle.importKey(
    "spki",
    keyData,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );

  const encoded = new TextEncoder().encode(password);
  const encrypted = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    cryptoKey,
    encoded
  );

  return `${PASSWORD_ENCRYPTION_CONFIG.prefix}${toBase64(encrypted)}`;
};
